(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tbf-free-gift-popup"]) return;
  try {
    
  (() => {
    if (customElements.get('tbf-free-gift-popup')) return;

    const quantitiesByProduct = (cart) => {
      const quantities = new Map();
      for (const item of cart?.items ?? []) {
        const productId = Number(item.product_id);
        quantities.set(productId, (quantities.get(productId) ?? 0) + Number(item.quantity ?? 0));
      }
      return quantities;
    };

    const getIncreasedProductIds = (previousCart, currentCart) => {
      const previous = quantitiesByProduct(previousCart);
      const current = quantitiesByProduct(currentCart);
      return [...current.entries()]
        .filter(([productId, quantity]) => quantity > (previous.get(productId) ?? 0))
        .map(([productId]) => productId);
    };

    class TbfFreeGiftPopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('[data-gift-form]');
        this.error = this.querySelector('[data-error]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.qualifyingProductIds = this.readIdSet('[data-qualifying-product-ids]');
        this.giftProductIds = this.readIdSet('[data-gift-product-ids]');
        this.previousFocus = null;
        this.cartPromise = this.fetchCart();
        this.onCartAdded = this.onCartAdded.bind(this);

        document.addEventListener('theme:cart:added', this.onCartAdded);
        this.form?.addEventListener('change', () => {
          this.submitButton.disabled = !this.form.querySelector('[type="radio"]:checked');
        });
        this.form?.addEventListener('submit', (event) => this.addGift(event));
        this.querySelector('[data-close]')?.addEventListener('click', () => this.close());
        this.querySelector('[data-skip]')?.addEventListener('click', () => this.close());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('theme:cart:added', this.onCartAdded);
      }

      readIdSet(selector) {
        try {
          return new Set(JSON.parse(this.querySelector(selector)?.textContent ?? '[]').map(Number));
        } catch (_error) {
          return new Set();
        }
      }

      async fetchCart() {
        const response = await fetch(this.dataset.cartUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error('Unable to load cart');
        return response.json();
      }

      promptKey(cart) {
        return `tbf-free-gift-prompted:${cart.token ?? 'current-cart'}`;
      }

      wasPrompted(cart) {
        try {
          return sessionStorage.getItem(this.promptKey(cart)) === 'true';
        } catch (_error) {
          return false;
        }
      }

      rememberPrompt(cart) {
        try {
          sessionStorage.setItem(this.promptKey(cart), 'true');
        } catch (_error) {
          // The popup still works when browser storage is unavailable.
        }
      }

      async onCartAdded() {
        try {
          const previousCart = await this.cartPromise;
          const currentCart = await this.fetchCart();
          this.cartPromise = Promise.resolve(currentCart);

          const increasedProductIds = getIncreasedProductIds(previousCart, currentCart);
          const qualifyingAdded = increasedProductIds.some((id) => this.qualifyingProductIds.has(id));
          const giftAlreadyInCart = currentCart.items.some((item) => this.giftProductIds.has(Number(item.product_id)));

          if (qualifyingAdded && !giftAlreadyInCart && !this.wasPrompted(currentCart)) {
            this.rememberPrompt(currentCart);
            this.open();
          }
        } catch (_error) {
          this.cartPromise = this.fetchCart();
        }
      }

      open() {
        if (!this.dialog || this.dialog.open) return;
        this.previousFocus = document.activeElement;
        this.error.textContent = '';
        this.dialog.showModal();
      }

      close() {
        if (!this.dialog?.open) return;
        this.dialog.close();
        this.previousFocus?.focus?.();
      }

      setLoading(isLoading) {
        this.submitButton.disabled = isLoading;
        this.form.querySelectorAll('input, button').forEach((control) => {
          control.disabled = isLoading;
        });
        this.querySelector('[data-submit-label]').hidden = isLoading;
        this.querySelector('[data-loading-label]').hidden = !isLoading;
      }

      refreshCart() {
        if (typeof window.cart?.getCart === 'function') {
          window.cart.getCart();
          return;
        }

        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
      }

      async addGift(event) {
        event.preventDefault();
        const selected = this.form.querySelector('[type="radio"]:checked');
        if (!selected) return;

        this.error.textContent = '';
        this.setLoading(true);

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: [{ id: Number(selected.value), quantity: 1 }] }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add gift');

          this.cartPromise = this.fetchCart();
          this.close();
          this.refreshCart();
        } catch (_error) {
          this.error.textContent = this.dataset.errorMessage;
          this.setLoading(false);
          this.submitButton.disabled = !this.form.querySelector('[type="radio"]:checked');
        }
      }
    }

    customElements.define('tbf-free-gift-popup', TbfFreeGiftPopup);
  })();

  } catch(e) { console.error(e); }
})();
})();
